import { render, staticRenderFns } from "./AttendanceGroup.vue?vue&type=template&id=27f9ff67&scoped=true&"
import script from "./AttendanceGroup.vue?vue&type=script&lang=js&"
export * from "./AttendanceGroup.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceGroup.vue?vue&type=style&index=0&id=27f9ff67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f9ff67",
  null
  
)

export default component.exports